import * as React from 'react';
import { FC } from 'react';
import { Day as AdventDay } from './types';
import locales from './locales';
import boxClosed from './images/box_closed.png';
import boxReady from './images/box_ready.png';
import boxOpened from './images/box_opened.png';
import Gift from './images/Gift';
import { dayOfMonth, isRewarded, isDeposited, isPast, isSelectable } from './days';

type OnSelect = (day: AdventDay) => void;
type CalendarProps = { days: AdventDay[]; selectedDay: AdventDay | undefined; onSelect: OnSelect };
type DayProps = {
  day: AdventDay;
  selected: boolean;
  onSelect: OnSelect;
};

const Title = () => (
  <div className="calendar_top">
    <Gift />
    <h2 className="calendar_title">
      {locales().get_a_prize_1}&nbsp;<span className="highlighted_text">{locales().get_a_prize_2}</span>
    </h2>
  </div>
);

const Image = ({ day }: { day: AdventDay }) => {
  if (isRewarded(day)) return <img src={boxOpened} alt="rewarded" />;
  return isDeposited(day) ? <img src={boxReady} alt="deposited" /> : <img src={boxClosed} alt="no deposit" />;
};

const dayClasses = (day: AdventDay, selected: boolean): string =>
  `calendar_day c-day` +
  `${selected ? ' selected' : ''}` +
  `${isPast(day) ? ' past' : ''}` +
  `${isRewarded(day) ? '' : ' not_rewarded'}`;

const Day = ({ day, selected, onSelect }: DayProps) => {
  const d = dayOfMonth(day.date);
  const m = locales().december;
  const isButton = isSelectable(day) && !selected;

  return (
    <div
      className={dayClasses(day, selected)}
      aria-label={`${d} ${m}`}
      onClick={isButton ? () => onSelect(day) : undefined}
      style={isButton ? { cursor: 'pointer' } : {}}
    >
      <div className="c-day_top">
        <div className="c-day_day">{d}</div>
        <div className="c-day_month">{m}</div>
      </div>
      <div className="c-day_image">
        <Image day={day} />
      </div>
    </div>
  );
};

const Days = ({ days, selectedDay, onSelect }: CalendarProps) => (
  <div className="calendar_days">
    {days.map((day) => (
      <Day key={day.date} day={day} selected={day && day === selectedDay} onSelect={onSelect} />
    ))}
  </div>
);

const Calendar: FC<CalendarProps> = (props) => (
  <div className="calendar">
    <Title />
    <Days {...props} />
  </div>
);

export default Calendar;
